import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('NameIdModel')
export class NameIdModel {
  @JsonProperty('id', Number) public id: number = undefined;
  @JsonProperty('name', String) public name: string = undefined;
}
